import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Helmet } from "react-helmet";
import FeaturedProductCard from "../HomePage/FeaturedProductCard";
import AvailableOn from "../AvailableOn/AvailableOn";
import Preloader from "../../Preloader";
import { getProductByCategoryID } from "../../services/productService";
import "./Style.css";

function CategoryProductsPage() {
  const { categoryId } = useParams();

  const { data: products = [], isLoading } = useQuery({
    queryKey: ["category-products", categoryId],
    queryFn: () => getProductByCategoryID(categoryId),
    enabled: Boolean(categoryId),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categoryId]);

  if (isLoading) {
    return <Preloader />;
  }

  const categoryName =
    products.find((product) => product?.category_name)?.category_name ||
    `Category ${categoryId}`;

  return (
    <>
      <Helmet>
        <title>{`${categoryName} | Kuku Namkeen`}</title>
        <meta
          name="description"
          content={`Explore Kuku Namkeen products from ${categoryName}.`}
        />
        <link
          rel="canonical"
          href={`https://kukunamkeen.in/category/${categoryId}`}
        />
      </Helmet>

      <section className="products-page category-products-page">
        <section className="dist-header-title">
          <div className="max-w-6xl mx-auto px-4">
            <h1>{categoryName}</h1>
          </div>
        </section>
        <img
          src="/Image/border-bottom-title.png"
          className="w-full header-title-image"
          alt=""
        />

        <section className="products-browser category-products-browser">
          {products.length > 0 ? (
            <div className="fp-grid products-card-grid">
              {products.map((product) => (
                <FeaturedProductCard
                  key={product.product_id || product.slug}
                  product={product}
                />
              ))}
            </div>
          ) : (
            <div className="products-empty">
              No products available in this category right now.
            </div>
          )}
        </section>
      </section>

      <AvailableOn />
    </>
  );
}

export default CategoryProductsPage;
